import type {
  VersionChangeHandlerProps,
  VersionChangeManager,
} from "@indietabletop/appkit";
import type { GreathelmIndexes, GreathelmSchema } from "./database.ts";

type Manager = VersionChangeManager<GreathelmSchema, GreathelmIndexes>;

type HandlerProps = VersionChangeHandlerProps<
  GreathelmSchema,
  GreathelmIndexes
>;

function createGangsStore(manager: Manager) {
  const store = manager.createObjectStore("warbands", { keyPath: "id" });
  store.createIndex("createdTs", "createdTs");
  store.createIndex("updatedTs", "updatedTs");
  store.createIndex("rulesetVersion", "rulesetVersion");
}

/**
 * Initializes database from scratch.
 *
 * This function should be updated every time a new migration is added to
 * make sure that migrated and new databases are always in sync.
 */
export function initDatabase({ manager }: HandlerProps) {
  createGangsStore(manager);

  console.info("DB initialized.");
}
